import { useState } from "#imports";

export const useUmbracoLoggedInState = () => useState<boolean | null>( "umbraco-logged-in", () => null );

export const useUmbracoPreviewModeApiKey = () => useState<string | null>( "preview-mode-api-key", () => null );

export const useUmbracoPreviewModeState = () => useState<boolean>( "umb-preview-mode", () => false );
